/** 設定でアバターを PUT/DELETE したときに進める。Chat はこれが変わったときだけ画像を取り直す。 */
const STORAGE_KEY = 'memo-app-avatar-revision';

export function bumpAvatarRevision(): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
}

export function getAvatarRevision(): number {
  try {
    const s = sessionStorage.getItem(STORAGE_KEY);
    if (s == null || s === '') return 0;
    const n = Number(s);
    return Number.isFinite(n) ? n : 0;
  } catch {
    return 0;
  }
}
